import { useQuery } from '@tanstack/react-query'
import { fetchCoinAll } from '@api/common/api.js'
import { useOrgErrorPolicy } from '@hooks/useOrgErrorPolicy.js'

const selectCoinAll = (data) => {
  return Array.isArray(data?.coins) ? data.coins : Object.values(data?.coins ?? {})
}

export const useCoinAllQuery = () => {
  const { throwOnError } = useOrgErrorPolicy()

  return useQuery({
    queryKey: ['coin-all'],
    queryFn: () => fetchCoinAll(),
    select: selectCoinAll,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: false,
    throwOnError
  })
}
